/** Australian address line helpers for quote/invoice preview (match PDF). */

const AU_STATE_NAMES = {
  'new south wales': 'NSW',
  nsw: 'NSW',
  victoria: 'VIC',
  vic: 'VIC',
  queensland: 'QLD',
  qld: 'QLD',
  'south australia': 'SA',
  sa: 'SA',
  'western australia': 'WA',
  wa: 'WA',
  tasmania: 'TAS',
  tas: 'TAS',
  'northern territory': 'NT',
  nt: 'NT',
  'australian capital territory': 'ACT',
  act: 'ACT'
}

export function normalizeAustralianState (state) {
  if (state == null || state === '') return ''
  const raw = String(state).trim()
  if (!raw) return ''
  const upper = raw.toUpperCase().replace(/\./g, '')
  if (/^(NSW|VIC|QLD|SA|WA|TAS|NT|ACT)$/.test(upper)) return upper
  const key = raw.toLowerCase().replace(/\s+/g, ' ').trim()
  if (AU_STATE_NAMES[key]) return AU_STATE_NAMES[key]
  const first = key.split(/\s+/)[0]
  if (AU_STATE_NAMES[first]) return AU_STATE_NAMES[first]
  if (upper.length <= 3 && /^[A-Z]{2,3}$/.test(upper)) return upper
  return upper.length <= 3 ? upper : upper.slice(0, 3)
}

/**
 * One line: suburb, postcode, state (e.g. "Melbourne 3000 VIC").
 * Accepts display settings shape (post_code) or contact shape (postcode).
 */
export function formatSuburbPostcodeStateLine (suburb, postcode, state) {
  const parts = []
  const su = suburb != null ? String(suburb).trim() : ''
  const pc = postcode != null ? String(postcode).trim() : ''
  const st = normalizeAustralianState(state)
  if (su) parts.push(su)
  if (pc) parts.push(pc)
  if (st) parts.push(st)
  return parts.join(' ')
}
